import { useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import AdminSidebar from "./components/AdminSidebar";
import AdminTopbar from "./components/AdminTopbar";

export default function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const token = localStorage.getItem("adminToken");

  if (!token) {
    return <Navigate to="/adminlogin" replace />;
  }

  return (
    <div className="min-h-screen bg-gray-50 text-gray-900 font-sans">
      <AdminTopbar setSidebarOpen={setSidebarOpen} sidebarOpen={sidebarOpen} />

      <div className="flex h-[calc(100vh-5rem)]">
        <AdminSidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

        <main className="flex-1 overflow-auto p-4 md:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}